export const hertzColors = {
  offWhite: '#fafafa',
  darkerOffWhite: '#f0f0f0',

  yellow: '#ffdf03',
  yellowDark: '#ffcc00',

  lightBlack: '#321e1e',
  black: '#211414',
  blackTransparent: '#000000d2',

  lightGray: '#dbdbdb',
  gray: '#95989a',
  darkGray: '#9a9a9a',

  error: '#f44336',
  success: '#4CAF50',

  softError: '#ffeef0',
  softSuccess: '#e6ffed',

  warningBackground: '#E305052B',
  warningText: '#D11209',
};
